﻿// This file contains JavaScript code for the depots overview page
import { downloadDocument } from "../../features";
import { addLoadingState, removeLoadingState, setVisibility } from "../helpers";

export function initDepotsPage() {
    addDialogLinkListener('what-to-declare-construction');
    addDialogLinkListener('what-to-declare-sustainability');

    document.querySelectorAll('[id*="ExtendBtn"]').forEach(el => {
        el.addEventListener('click', extend);
    });

    document.addEventListener('dialog:contentready', function (event) {
        const cancelBtn = document.querySelector('#cancel-extend-form');
        if (cancelBtn) {
            cancelBtn.addEventListener('click', () => {
                window.dialog.close();
            });
        }
    });

    // Add this block to handle downloadDeclarationDocuments buttons
    document.querySelectorAll('[id^="downloadDeclarationDocument-"]').forEach(el => {
        el.addEventListener('click', downloadDeclarationDocument);
    });

    document.querySelectorAll('[id^="transaction-details"]:not([id$="-content"])').forEach(el => {
        const id = el.id + "-content";
        el.addEventListener('click', () => {
            window.dialog.open({ elemId: id, size: "small" })
        });
    });
    
    const cesKey = document.querySelector("[data-ces-key]")?.dataset?.cesKey;
    window.customerEffortScore.trigger(cesKey); 
}

function addDialogLinkListener(dialogId) {
    const link = document.getElementById(dialogId + "-link");
    if (!link) return;

    link.addEventListener('click', function (event) {
        const dialogElem = document.getElementById(dialogId);
        if (!dialogElem) {
            console.error("Dialog with id: '" + dialogId + "' not found");
            return;
        }

        const titleElem = dialogElem.querySelector('[data-role="dialog-title"]');
        const title = titleElem ? titleElem.textContent : '';
        window.dialog.open({ elemId: dialogId, title: title });
    });
}

function extend(event) {
    event.preventDefault();

    const href = event.currentTarget.getAttribute('data-href');
    event.currentTarget.classList.add("loading");
    window.dialog.open({ url: href });
    event.currentTarget.classList.remove("loading");
}

function downloadDeclarationDocument(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const href = button.dataset.href.replaceAll('&amp;', '&');
    const icon = button.querySelector('.icon');

    addLoadingState(event);
    setVisibility(icon, false);

    downloadDocument(href)
        .catch(error => {
            // after Stefano has introduced a toaster component this alert can be replaced with a toaster, which can probably accept a contentful key and retrieves it's own content
            alert(error);
        }).finally(() => {
            setVisibility(icon, true);
            removeLoadingState(button);
        });
}